import assertString from './util/assertString';

export default function isLowercase(str) {
  assertString(str);
  return str === str.toLowerCase();
}
